const isAuthenticate = () => {
    return localStorage.getItem('userToken')
}

export default isAuthenticate
